module.exports = __webpack_public_path__ + "static/contactbg-46b4f39f1f5e5e221832df3598efbf84.jpg";